import { render, staticRenderFns } from "./TrialItem.vue?vue&type=template&id=b998867a&scoped=true"
import script from "./TrialItem.vue?vue&type=script&lang=js"
export * from "./TrialItem.vue?vue&type=script&lang=js"
import style0 from "./TrialItem.vue?vue&type=style&index=0&id=b998867a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b998867a",
  null
  
)

export default component.exports